import React from 'react'

import PixelMenu from 'app/common/pixel-menu/pixel-menu'

const SidebarMenu = () => {
  return (
    <PixelMenu
      route={window.location.pathname}
      isVisible={true}
      onClose={() => {}}
    />
  )
}

export default SidebarMenu
